// Copyright © Aptos
// SPDX-License-Identifier: Apache-2.0

export enum NetworkName {
  DEVNET = 'devnet',
  MAINNET = 'mainnet',
  TESTNET = 'testnet',
}
